module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$root.user != ''),
      expression: "this.$root.user != ''"
    }],
    staticClass: "profile-overlay-menu hide"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "user-data"
  }, [_c('div', {
    staticClass: "photo",
    style: (_vm.photoStyle)
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n        " + _vm._s(this.$root.user.name) + "\n        ")])])])]), _vm._v(" "), _c('a', {
    staticClass: "logout",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": this.$root.logout
    }
  }, [_c('i', {
    staticClass: "fa fa-power-off"
  }), _vm._v("Kijelentkezés")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cfb73704"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/tpl_profile_menu.vue
// module id = 402
// module chunks = 0